import { NavigationItem } from '@markant-platform/shared/navigation/model';
import { StaticRole } from '@markant-platform/shared/user/model';
import { NAVIGATION_OA_ITEMS, NAVIGATION_PFA_ITEMS, NAVIGATION_SA_ITEMS } from './navigation.config';

export function getAdminChildrenFromRoles(roles: StaticRole[]): NavigationItem[] {
  let uniqueItems: NavigationItem[] = [];

  // OA always appears first
  if (roles.includes(StaticRole.ORGANIZATION_ADMIN)) {
    uniqueItems = [...NAVIGATION_OA_ITEMS];
  }

  if (roles.includes(StaticRole.PLATFORM_ADMIN)) {
    uniqueItems = [...uniqueItems, ...NAVIGATION_PFA_ITEMS];
  }

  if (roles.includes(StaticRole.LEISTUNG_ADMIN)) {
    uniqueItems = [...uniqueItems, ...NAVIGATION_SA_ITEMS];
  }

  return uniqueItems;
}

export function getAdminRouteFromRoles(roles: StaticRole[]): string {
  if (roles.includes(StaticRole.PLATFORM_ADMIN)) {
    return '/backoffice';
  } else if (roles.includes(StaticRole.ORGANIZATION_ADMIN)) {
    return '/organization';
  } else if (roles.includes(StaticRole.LEISTUNG_ADMIN)) {
    return '/cartridge-admin';
  } else if (roles.includes(StaticRole.ORGANIZATION_MEMBER)) {
    return '/organization-contact';
  }

  return '';
}
